<div class="p-6" data-testid="batch-detail-page">
  <div class="mb-4 flex align-items-center justify-content-between gap-3">
    <h2 class="m-0 text-2xl font-semibold">
      {{ 'batch_management.detail.title' | translate }}
    </h2>
    <app-button
      [testId]="'batch-detail-back'"
      type="secondary"
      [outlined]="true"
      icon="arrow_back"
      [label]="'batch_management.detail.back' | translate"
      (emitOnClick)="back()"
    />
  </div>

  @if (loading()) {
    <p>{{ 'common.loading' | translate }}</p>
  } @else if (!batch()) {
    <p>{{ 'common.no_data' | translate }}</p>
  } @else {
    <article class="border-1 border-round p-4 surface-card mb-4">
      <h3 class="mt-0">{{ batch()!.lotValue || batch()!.batchId }}</h3>
      <div class="grid">
        <div class="col-12 md:col-6">
          <p class="m-0">
            {{ 'batch_management.form.fields.batch_id' | translate }}:
            {{ batch()!.batchId }}
          </p>
          <p class="m-0">
            {{ 'batch_management.table.columns.sku_code' | translate }}:
            {{ batch()!.skuCode }}
          </p>
          <p class="m-0">
            {{ 'batch_management.form.fields.sku_name' | translate }}:
            {{ batch()!.skuName || '-' }}
          </p>
          <p class="m-0">
            {{ 'batch_management.form.fields.quantity' | translate }}:
            {{ batch()!.qty }}
          </p>
          <p class="m-0">
            {{ 'batch_management.table.columns.status' | translate }}:
            {{ batch()!.status }}
          </p>
        </div>
        <div class="col-12 md:col-6">
          <p class="m-0">
            {{ 'batch_management.form.fields.warehouse' | translate }}:
            {{ batch()!.warehouseName || batch()!.warehouseId || '-' }}
          </p>
          <p class="m-0">
            {{ 'batch_management.form.fields.expiry_date' | translate }}:
            {{ formatDate(batch()!.expiryDate) }}
          </p>
          <p class="m-0">
            {{ 'batch_management.form.fields.manufacture_date' | translate }}:
            {{ formatDate(batch()!.manufactureDate) }}
          </p>
        </div>
      </div>
    </article>

    <article class="border-1 border-round p-4 surface-card mb-4">
      <h3 class="mt-0">{{ 'batch_management.detail.origin' | translate }}</h3>
      <p class="m-0">
        {{ 'lot_trace.source_type' | translate }}:
        {{ formatSourceType(batch()!.sourceType) }}
      </p>
      <p class="m-0">
        {{ 'lot_trace.inbound' | translate }}:
        {{ batch()!.sourceWarrantCode || '-' }}
      </p>
      <p class="m-0">
        {{ 'lot_trace.source' | translate }}:
        {{ batch()!.sourceRecordCode || '-' }}
      </p>
      <p class="m-0">
        {{ 'lot_trace.supplier' | translate }}:
        @if (batch()!.supplierMissing) {
          {{ 'lot_trace.supplier_missing' | translate }}
        } @else {
          {{ batch()!.supplierName || batch()!.supplierCode || '-' }}
        }
      </p>
    </article>

    <article class="border-1 border-round p-4 surface-card">
      <h3 class="mt-0">{{ 'lot_trace.receipts' | translate }}</h3>
      <p-table
        [value]="batch()!.receipts || []"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 50]"
        [alwaysShowPaginator]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'lot_trace.received_at' | translate }}</th>
            <th>{{ 'lot_trace.inbound' | translate }}</th>
            <th>{{ 'lot_trace.source_type' | translate }}</th>
            <th>{{ 'lot_trace.source' | translate }}</th>
            <th>{{ 'lot_trace.qty' | translate }}</th>
            <th>{{ 'lot_trace.supplier' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ formatDateTime(row.receivedAt) }}</td>
            <td>{{ row.warrantCode || '-' }}</td>
            <td>{{ formatSourceType(row.sourceType) }}</td>
            <td>{{ row.sourceRecordCode || '-' }}</td>
            <td>{{ row.qtyReceived }}</td>
            <td>{{ row.supplierName || row.supplierCode || '-' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center text-color-secondary py-4">
              {{ 'batch_management.detail.receipts_empty' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </article>
  }
</div>
<p-toast />
